<template>
  <transition name="modal">
    <div class="modal-mask">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        v-bind:style="{ width: modalWidth, height: modalHeight }"
      >
        <div class="modal-content">
          <div class="popup_header">
            <slot name="header"> </slot>
          </div>
          <div class="modal-body">
            <slot name="body"> </slot>
          </div>
          <div class="modal-footer popup_bottom">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default { props: ["modalWidth", "modalHeight"] };
</script>

<style></style>
